import $ from 'jquery';
import ApplicationController from './application_controller';
import log from '../lib/logger';

/*
 * Permission Toggle Controller
 *
 * Posts a grant/revoke request when a permission (or permission group)
 * switch is toggled, then pulses the row. The response is a js.erb that
 * re-renders the row, so the request keeps jQuery's `dataType: 'script'`.
 *
 * Usage:
 *   <input type="checkbox"
 *          data-controller="permission-toggle"
 *          data-action="change->permission-toggle#toggle"
 *          data-permission-toggle-url-value="/path/to/toggle"
 *          data-permission-toggle-params-value='{"permission_id":"..."}'
 *          data-permission-toggle-row-value="perm-tr-...">
 *
 * Replaces the per-page `permissionManager` head scripts, which registered
 * document-delegated handlers with the toggle URL baked into a closure.
 * Under Turbo Drive those scripts persisted across visits, so toggling a
 * permission on one user's page could POST to the previously viewed user's
 * URL. Binding to the element scopes each toggle to its own row and URL.
 */
export default class extends ApplicationController {
  static values = {
    url: String,
    params: Object,
    row: String,
  };

  toggle() {
    const row = document.getElementById(this.rowValue);
    if (row) row.classList.remove('table-background-update-pulse');
    this.element.parentElement.classList.add('saving');
    this.element.blur();

    $.ajax({
      url: this.urlValue,
      type: 'POST',
      dataType: 'script',
      data: { ...this.paramsValue, grant_revoke: this.element.checked ? 'grant' : 'revoke' },
      error(res) {
        log.error(res);
      },
      success() {
        if (row) row.classList.add('table-background-update-pulse');
      },
    });
  }
}
